export const en = {
  // Главная | Main
  totalBalance: 'Total Balance',
  profit: 'Profit',
  convert: 'Convert',
  balance: 'Balance',
  foxBalance: '{tokenName} Balance',
  exchange: 'Exchange',
  deposit: 'Deposit',
  withdraw: 'Withdraw',
  arbitrageHistory: 'Arbitrage History',
  spread: 'Spread',
  
  // Уведомления | Notifications
  notifications: 'Notifications',
  automaticTradeExecuted: 'Automatic Trade Executed',
  automaticTradeExecutedDesc: 'An automatic arbitrage trade {pair} was executed between {exchange1} and {exchange2}. Profit: ${profit}.',
  autoArbitrageStarted: 'Auto-Arbitrage Started',
  autoArbitrageStartedDesc: 'Auto-Arbitrage has been activated for {pairs} currency pairs. {trades} trades are planned.',
  autoArbitrageStopped: 'Auto-Arbitrage Stopped',
  autoArbitrageStoppedDesc: 'Auto-Arbitrage was stopped by the user.',
  autoArbitrageCompleted: 'Auto-Arbitrage Completed',
  autoArbitrageCompletedDesc: 'All planned trades ({trades}) were successfully executed. Profit: ${profit}.',
  
  // Настройки | Settings
  settings: 'Settings',
  display: 'DISPLAY',
  fullscreenMode: 'Fullscreen Mode',
  fullscreenModeDesc: 'Use the full screen for a better experience',
  supportContact: 'If you have any questions or issues, please contact our support team.',
  information: 'Information',
  visitOfficialWebsite: 'Visit our official resources for additional information and updates.',
  technicalSupport: 'Technical Support',
  
  // Транзакции | Transactions
  transactionHistory: 'Transaction History',
  withdrawProfit: 'Withdraw Profit',
  all: 'All',
  deposits: 'Deposits',
  withdrawals: 'Withdrawals',
  licenses: 'Licenses',
  upgrades: 'Upgrades',
  reinvest: 'Reinvest',
  referral: 'Referral',
  status: 'Status',
  withdrawal: 'Withdrawal',
  
  // Арбитраж | Arbitrage
  balanceAndLimits: 'Balance and Limits',
  availableTrades: 'Available Trades',
  chooseTradeMode: 'Choose Trade Mode',
  manual: 'Manual',
  refreshTrades: 'Refresh Trades',
  available: 'Available',
  signalInactive: 'Signal Inactive',
  buyPrices: 'Buy Prices',
  bestConditions: 'Best Conditions',
  buyOn: 'Buy on',
  sellOn: 'Sell on',
  start: 'Start',
  automatic: 'Automatic',
  autoTradingSettings: 'Auto-Trading Settings',
  currencyPairs: 'Currency Pairs',
  selectedPairs: 'Selected: {count} pairs',
  selectedPair: 'Selected: {count} pair',
  selectedPairsPlural: 'Selected: {count} pairs',
  numberOfTrades: 'Number of Trades',
  spreadRange: 'Spread Range',
  from: 'From',
  to: 'To',
  spreadRangeDesc: 'Auto-trading will search for opportunities within the specified spread range',
  amountPerTrade: 'Amount per Trade ($)',
  amountPerTradeValue: 'Amount per trade: ${amount}',
  startAutoArbitrage: 'Start Auto-Arbitrage',
  starting: 'Starting...',
  checkCurrentSessionStatus: 'Check Current Session Status',
  checking: 'Checking...',
  refreshStatus: 'Refresh Status',
  autoTradingParameters: 'Auto-Trading Parameters',
  automationAmount: 'Automation Amount',
  targetProfit: 'Target Profit',
  executionConditions: 'Execution Conditions',
  tradesRemaining: 'Trades Remaining',
  autoArbitrageActive: 'Auto-Arbitrage is active. The system is automatically searching for and executing arbitrage opportunities',
  stopAutoArbitrage: 'Stop Auto-Arbitrage',
  stopping: 'Stopping...',
  completed: 'Completed',
  results: 'Results',
  totalProfit: 'Total Profit',
  averageProfitPerTrade: 'Average Profit per Trade',
  autoTradingCompletedDesc: 'Auto-trading completed! {executed} out of {total} trades executed.\nYou can view the statistics and start a new session.',
  startNewSession: 'Start New Session',
  
  // Лицензии | Licenses
  currentLicense: 'Current License',
  perDay: 'per day',
  licensesAndFeatures: 'Licenses and Features',
  tradeVolume: 'Trade Volume',
  buy: 'Buy',
  purchased: 'Purchased',
  insufficientFunds: 'Insufficient Funds',
  needToTopUp: 'You need to top up your balance by {amount} USDT',
  
  // Реферальная | Referral
  yourReferralLink: 'Your Referral Link',
  referralStatistics: 'Referral Statistics',
  numberOfActiveReferrals: 'Number of Active Referrals',
  totalReferralDeposits: 'Total Referral Deposits',
  totalArbitrageProfit: 'Total Arbitrage Profit',
  myReferrals: 'My Referrals',
  level1: 'Level 1',
  level2: 'Level 2',
  level3: 'Level 3',
  level4: 'Level 4',
  level5: 'Level 5',
  quantity: 'Quantity',
  
  // Баланс на биржах | Exchange Balance
  exchangeBalance: 'Exchange Balance',
  connectExchange: 'Connect Exchange',
  selectExchange: 'Select Exchange',
  apiKey: 'API Key',
  privateKey: 'Private Key',
  secretWord: 'Secret Word',
  enterApiKey: 'Enter API key',
  enterPrivateKey: 'Enter private key',
  enterSecretWord: 'Enter secret word',
  connect: 'Connect',
  connecting: 'Connecting...',
  fillAllFields: 'Fill all fields',
  secretWordRequired: 'Secret word is required for this exchange',
  connectionFailed: 'Exchange connection failed',
  howToGetApiKey: 'How to get API key?',
  apiDocumentation: 'API Documentation',

  // Управление биржами | Exchange Management
  exchangeManagement: 'Exchange Management',
  exchangeManagementDescription: 'Connect exchanges, view balances and manage API keys',
  connectedExchanges: 'Connected Exchanges',
  addExchange: 'Add Exchange',
  noExchangesConnected: 'No Exchanges Connected',
  noExchangesDescription: 'Connect your first exchange to view balances and enable automated trading',
  connectFirstExchange: 'Connect First Exchange',
  connected: 'Connected',
  connectionError: 'Connection Error',
  disconnected: 'Disconnected',
  lastUpdate: 'Last Update',
  balances: 'Balances',
  summary: 'Summary',
  totalExchanges: 'Total Exchanges',
  connectedCount: 'Connected',
  totalBalanceAllExchanges: 'Total Balance All Exchanges',
  loadExchangesError: 'Error loading exchange list',
  disconnectExchangeError: 'Error disconnecting exchange',

  // Общие | Common
  language: 'Language',
  russian: 'Русский',
  english: 'English',
  cancel: 'Cancel',
  confirm: 'Confirm',
  close: 'Close',
  save: 'Save',
  loading: 'Loading...',
  error: 'Error',
  success: 'Success',
  warning: 'Warning',
  info: 'Info',
  update: 'Update',
  
  // Формы | Forms
  amount: 'Amount',
  currency: 'Currency',
  address: 'Address',
  walletAddress: 'Wallet Address',
  enterAmount: 'Enter amount',
  enterAddress: 'Enter wallet address',
  processing: 'Processing...',
  
  // Модальные окна | Modals
  depositModal: 'Deposit',
  withdrawModal: 'Withdraw Profit',
  availableForWithdraw: 'Available for withdrawal',
  amountToWithdraw: 'Amount to withdraw',
  minimumWithdrawal: 'Minimum withdrawal',
  
  // История | History
  loadingHistory: 'Loading operation history...',
  historyError: 'Failed to load operation history',
  retry: 'Retry',
  noArbitrageOperations: 'You have no arbitrage operations yet',
  date: 'Date',
  time: 'Time',
  
  // Навигация | Navigation
  dashboard: 'Dashboard',
  transactions: 'Transactions',
  arbitrage: 'Arbitrage',
  referrals: 'Referrals',
  admin: 'Admin',
  
  // Админ панель | Admin Panel
  adminDashboard: 'Admin Dashboard',
  adminTitle: 'Admin Panel',
  adminInfo: 'Administrator:',
  accessDeniedTitle: 'Access Denied',
  accessDeniedDescription: 'You do not have administrator privileges',
  
  // Перенос рефералов | Referral Transfer
  referralTransfer: 'Referral Transfer',
  referralTransferTitle: 'Referral Transfer',
  referralTransferDescription: 'Move a user (by username) under a new referrer with their entire 5-level structure',
  usernameUser: 'User Username',
  usernamePlaceholder: 'Enter username without @',
  usernameHint: 'Username of the user to be transferred with their entire structure',
  newReferrer: 'New Referrer (username)',
  newReferrerPlaceholder: 'Enter username without @',
  newReferrerHint: 'Username of the user to place under',
  transferring: 'Transferring...',
  transferStructure: 'Transfer with Structure',
  transfer: 'Transfer',
  searchUsers: 'Search users...',
  noUsersFound: 'No users found',
  
  // Управление выводами | Withdrawal Management
  withdrawalManagement: 'Withdrawal Management',
  withdrawalManagementTitle: 'Withdrawal Management',
  withdrawalManagementDescription: 'Approve or reject withdrawal requests',
  activeWithdrawals: 'Active Withdrawals',
  loadingWithdrawals: 'Loading requests...',
  noActiveWithdrawals: 'No active withdrawal requests',
  approve: 'Approve',
  reject: 'Reject',
  approved: 'Approved',
  confirmApproval: 'Confirm Transfer',
  confirmRejection: 'Reject Request',
  approvalQuestion: 'Did you actually transfer the money to the user?',
  rejectionQuestion: 'Do you really want to reject this withdrawal? The money will be returned to the user\'s balance.',
  
  // Управление бонусами | Bonus Management
  bonusManagement: 'Bonus Management',
  bonusManagementTitle: 'Give Bonuses',
  bonusManagementDescription: 'Give bonus money or additional deals to users',
  giveBonusMoney: 'Give Bonus Money',
  giveBonusDeals: 'Give Bonus Deals',
  bonusMoney: 'Bonus Money',
  bonusDeals: 'Additional Deals',
  username: 'Username',
  bonusAmount: 'Bonus Amount (USDT)',
  bonusAmountPlaceholder: 'Enter amount',
  bonusDealsPlaceholder: 'Enter quantity',
  giving: 'Giving...',
  giveBonus: 'Give Bonus',
  give: 'Give',
  notSpecified: 'Not specified',
  
  // Статусы | Statuses
  pending: 'Pending',
  confirmed: 'Confirmed',
  rejected: 'Rejected',
  completed: 'Completed',
  active: 'Active',
  inactive: 'Inactive',
  
  // Уведомления об успехе/ошибке | Success/Error notifications
  referralTransferSuccess: 'Referral transferred successfully',
  withdrawalApproved: 'Withdrawal approved',
  withdrawalRejected: 'Withdrawal rejected',
  bonusMoneyGiven: 'Bonus money given',
  bonusDealsGiven: 'Bonus deals given',
  operationFailed: 'Operation failed',
  fillAllFields: 'Fill in all fields',
  addressCopied: 'Address copied to clipboard',
  addressCopyFailed: 'Failed to copy address',
  
  // Дополнительные тексты
  copyToClipboard: 'Copy to clipboard',
  copied: 'Copied!',
  clickToCopy: 'Click to copy',
  
  // Транзакции - страница | Transactions page
  topUp: 'Top Up',
  transactionsNotFound: 'No transactions found',
  transactionLoadError: 'Error loading transactions. Please try again later.',
  insufficientProfitForWithdrawal: 'Insufficient profit for withdrawal',
  withdrawalRequestError: 'Error creating withdrawal request',
  depositRequestError: 'Error creating deposit request',
  pay: 'Pay',
  amountToWithdrawLabel: 'Amount to withdraw',
  availableForWithdrawal: 'Available for withdrawal',
  depositAccountTitle: 'Account Deposit',
  
  // Статусы транзакций | Transaction statuses
  inProcessing: 'Processing',
  failed: 'Failed',
  
  // Типы транзакций | Transaction types
  topUpTransaction: 'Deposit',
  withdrawalTransaction: 'Withdrawal',
  licensePurchase: 'License Purchase',
  licenseUpgrade: 'License Upgrade',
  reinvestment: 'Reinvestment',
  referralCommission: 'Referral Commission',
  foxConversionTransaction: '{tokenName} Conversion',
  profitConversionTransaction: 'Profit Conversion',
  
  // Фильтры транзакций | Transaction filters
  allTransactions: 'All',
  depositsFilter: 'Deposits',
  withdrawalsFilter: 'Withdrawals',
  licensesFilter: 'Licenses',
  upgradesFilter: 'Upgrades',
  reinvestFilter: 'Reinvest',
  referralFilter: 'Referral',
  conversionsFilter: 'Conversions',
  
  // Лицензии - страница | Licenses page
  numberOfDeals: 'Number of deals',
  availableDeals: 'Available deals',
  currentLicenseLabel: 'Current license',
  licensesAndFeaturesTitle: 'Licenses and Features',
  numberOfDealsLabel: 'Number of deals',
  maxTradeVolumeLabel: 'Trade volume',
  maxTradeVolumeValue: 'max {amount} USDT',
  buyLicense: 'Buy',
  purchasedLicense: 'Purchased',
  insufficientFundsButton: 'Insufficient funds',
  needToTopUpBalance: 'You need to top up your balance by {amount} USDT',
  purchaseConfirmationTitle: 'Purchase Confirmation',
  purchaseConfirmationMessage: 'You are about to purchase {license} license for {price} USDT',
  failedToPurchaseLicense: 'Failed to purchase license. Please try again.',
  
  // Рефералы - страница | Referrals page
  copiedNotification: 'Copied',
  failedToLoadReferralData: 'Failed to load referral data',
  yourReferralLinkLabel: 'Your referral link',
  yourReferralsTurnover: 'Your referrals turnover',
  yourReferralLevel: 'Your referral level',
  referralStatsTitle: 'Referral Statistics',
  numberOfActiveReferralsLabel: 'Number of active referrals',
  totalReferralDepositsLabel: 'Total referral deposits',
  totalReferralBalanceLabel: 'Total referral balance',
  totalArbitrageProfitLabel: 'Total arbitrage profit',
  myReferralsTitle: 'My Referrals',
  levelLabel: 'Level {level}',
  quantityLabel: 'Quantity',
  depositLabel: 'Deposit',
  balanceLabel: 'Balance',
  profitLabel: 'Profit',
  viewReferrals: 'View Referrals',
  levelReferralsTitle: 'Level {level} Referrals',
  sortBy: 'Sort by',
  registrationDate: 'Registration Date',
  depositAmount: 'Deposit Amount',
  profitAmount: 'Profit Amount',
  loadingReferrals: 'Loading referrals...',
  previousPage: 'Previous',
  nextPage: 'Next',
  pageInfo: 'Page {current} of {total}',
  referralSystemConditionsTitle: 'Referral System Terms',
  referralSystemDescription: 'Simply share the tool with friends - get bonus deals and reduced commissions. The more team activity - the more privileges for you',
  statusTableHeader: 'Status',
  structureTurnoverTableHeader: 'Structure Turnover',
  partnersCountTableHeader: 'Number of Partners',
  levelsDepthTableHeader: 'Levels Depth',
  commissionReductionTableHeader: 'Commission Reduction',
  bonusDealsTableHeader: 'Bonus deals for partner trading volume (USDT)',
  maxDailyLimitTableHeader: 'Max daily limit of bonus deals',
  
  // Арбитраж - страница | Arbitrage page
  balanceAndLimitsTitle: 'Balance and Limits',
  availableTradesLabel: 'Available Trades',
  chooseTradeModeTitle: 'Choose Trade Mode',
  manualMode: 'Manual',
  automaticMode: 'Automatic',
  refreshTradesButton: 'Refresh Trades',
  signalAvailable: '• Available',
  signalNotActive: '• Signal Inactive',
  bestConditionsTitle: 'Best Conditions',
  buyOnLabel: 'Buy on',
  sellOnLabel: 'Sell on',
  spreadLabel: 'Spread',
  startButton: 'Start',
  
  // Автоторговля | Auto-trading
  autoTradingSettingsTitle: 'Auto-Trading Settings',
  currencyPairsLabel: 'Currency Pairs',
  numberOfTradesLabel: 'Number of Trades',
  enterNumberOfTrades: 'Enter number of trades',
  spreadRangeLabel: 'Spread Range (%)',
  fromLabel: 'From',
  toLabel: 'To',
  spreadRangeDescription: 'Auto-trading will search for opportunities within the specified spread range',
  amountPerTradeLabel: 'Amount per Trade ($)',
  startAutoTradingButton: 'Start Auto-Trading',
  startingAutoTrading: 'Starting...',
  checkingStatus: 'Checking...',
  
  // Статусы автоторговли | Auto-trading statuses
  autoTradingActive: 'Auto-trading is active. The system is automatically searching for and executing arbitrage opportunities...',
  autoTradingCompleted: 'Auto-trading completed! {completed} out of {total} trades executed. You can view the statistics and start a new session.',
  stopAutoTradingButton: 'Stop Auto-Trading',
  stoppingAutoTrading: 'Stopping...',
  statusCompleted: 'Completed',
  statusActive: 'Active',
  startNewSessionButton: 'Start New Session',
  
  // Этапы выполнения сделки | Trade execution steps
  connectingToExchange: 'Connecting to exchange',
  checkingLiquidity: 'Checking liquidity',
  buyingCoin: 'Buying coin',
  transferringCoin: 'Transferring coin',
  sellingCoins: 'Selling coins',
  fixingProfit: 'Fixing profit',
  
  // Сообщения об ошибках | Error messages
  insufficientBalanceForTrade: 'Insufficient balance to execute one trade',
  insufficientBalanceForTradeExecution: 'Insufficient balance to execute trade',
  insufficientBalanceMessage: 'Insufficient balance',
  insufficientBalanceDetailed: 'Insufficient balance for one trade. Required: ${required}, available: ${available}',
  insufficientFundsNote: '(insufficient funds)',
  minSpreadLowerThanMax: 'Minimum spread must be lower than maximum',
  failedToSetupAutoTrading: 'Failed to set up automatic trading. Please try again later.',
  failedToRestartAutoTrading: 'Failed to restart automatic trading. Please try again later.',
  
  // Завершение сделки | Trade completion
  tradeCompletedTitle: 'Trade Completed!',
  tradeCompletedMessage: 'Your arbitrage trade for {pair} pair has been successfully completed. Funds have been credited to your balance.',
  
  // Дополнительные переводы для Arbitrage | Additional Arbitrage translations
  errorRefreshingUserData: 'Failed to refresh user data',
  errorFetchingArbitrageOpportunities: 'Failed to load arbitrage opportunities. Please try again later.',
  minimumDealAmount: 'Minimum deal amount:',
  maximumDealAmount: 'Maximum deal amount:',
  failedToExecuteArbitrage: 'Failed to execute arbitrage trade. Please try again later.',
  enterAmount: 'Enter amount',
  
  // Дополнительные UI элементы | Additional UI elements
  noArbitrageOpportunitiesMessage: 'No available arbitrage opportunities. Try refreshing later.',
  
  // Форма торговли | Trade form
  trade: 'Trade',
  availableInDeposit: 'Available in deposit',
  minimumAmount: 'Minimum amount',
  maximumAmount: 'Maximum amount',
  next: 'Next',
  
  // Выполнение сделки | Trade execution
  launchArbitrageTrade: 'Launch Arbitrage Trade',
  tradeParameters: 'Trade Parameters',
  pair: 'Pair',
  volume: 'Volume',
  expectedProfit: 'Expected Profit',
  
  // Завершенная сделка | Completed trade
  tradeResults: 'Trade Results',
  currentBalance: 'Current Balance',
  platformCommission: 'Platform Commission',
  commissionTooltip: 'To reduce commission, invite partners: the more partners, the lower the commission!',
  commissionAmount: 'Commission Amount',
  done: 'Done',
  
  // Автоторговля - дополнительные переводы | Auto-trading - additional translations
  tradesProgress: 'Trades Progress',
  selectedPairsCount: 'Selected: {count} pairs',
  amountExceedsMaxDeal: 'Amount per trade cannot exceed ${maxAmount}',
  
  getFoxTokens: 'Get {tokenName} Tokens',
  getFoxTokensDescription: 'Get 10 {tokenName} tokens to improve your trading opportunities!',
  
  convertFoxTokens: 'Convert {tokenName} Tokens',
  conversionRate: 'Conversion Rate',
  availableFoxBalance: 'Available {tokenName} Balance',
  foxAmountToConvert: '{tokenName} Amount to Convert',
  enterFoxAmount: 'Enter {tokenName} amount',
  minimumConversion: 'Minimum conversion',
  foxToConvert: 'To convert',
  usdtToReceive: 'To receive',
  converting: 'Converting...',
  convertButton: 'Convert',
  minimumConversionAmount: 'Minimum conversion amount is 500 {tokenName}',
  insufficientFoxTokens: 'Insufficient {tokenName} tokens',
  conversionFailed: 'Conversion failed. Please try again later.',
  foxConversion: '{tokenName} Conversion',
  swipeToConvert: 'Swipe to convert',
  releaseToConvert: 'Release to convert',
  converted: 'Converted',
  convertProfitToBalance: 'Convert Profit to Balance',
  availableProfitBalance: 'Available Profit',
  profitAmountToConvert: 'Profit Amount to Convert',
  enterProfitAmount: 'Enter profit amount',
  profitToConvert: 'To convert',
  balanceToReceive: 'To receive in balance',
  swipeToConvertProfit: 'Swipe to convert profit',
  releaseToConvertProfit: 'Release to convert profit',
  minimumProfitConversionAmount: 'Minimum conversion amount is 1 USDT',
  insufficientProfit: 'Insufficient profit',
  profitConversionFailed: 'Profit conversion failed. Please try again later.',
  
  // New translations for improved UX
  noReferralsYet: 'You don\'t have any referrals yet',
  noReferralsAtThisLevel: 'No referrals at this level yet',
  
  // Trade Details
  tradeDetails: 'Trade Details',
  tradingPair: 'Trading Pair',
  exchanges: 'Exchanges',
  financialDetails: 'Financial Details',
  tradeAmount: 'Trade Amount',
  transactionSteps: 'Transaction Steps',
  buyOrder: 'Buy Order',
  sellOrder: 'Sell Order',
  profitRealized: 'Profit Realized',
  boughtOn: 'Bought on',
  soldOn: 'Sold on',
  addedToBalance: 'added to balance',
  completed: 'Completed',
  
  // Trading Activity | Trade Activity
}; 